import React from 'react'
import { Typography, List, ListItem, ListItemText } from '@mui/material'
import { LabTests } from '../../../labTests/models'
import { makeStyles } from '../../../../utils/hooks/makeStyles'

const useStyles = makeStyles(() => ({
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItem: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
  },
  primaryText: {
    fontSize: '0.75rem',
  },
}))

interface TestParametersListProps {
  parameters: LabTests[]
}

const TestParametersList: React.FC<TestParametersListProps> = ({
  parameters,
}) => {
  const classes = useStyles()

  if (!parameters || parameters.length === 0) {
    return (
      <Typography variant='caption' color='text.secondary'>
        No parameters
      </Typography>
    )
  }

  return (
    <List dense className={classes.list}>
      {parameters.map((item: LabTests) => (
        <ListItem key={item?.id} className={classes.listItem}>
          <ListItemText
            primary={item?.name}
            primaryTypographyProps={{
              variant: 'caption',
              className: classes.primaryText,
            }}
          />
        </ListItem>
      ))}
    </List>
  )
}

export default TestParametersList
